export default __webpack_public_path__ + "static/media/image5.97dc35e6.jpeg";